import defineComponent from 'flight';
import WithAjax from 'static/script/app/data/with-ajax';

function LastChanceService() {
    this._lastChanceVisible = function () {

        let onSuccess = function (html) {
            let $html = $(html);
            $html.find('a[id]').removeAttr('id'); // Remove id attribute to get rid of the javascript trying to scroll down to an element that has not been ajax-loaded yet

            let data = { html: $html };
            this.trigger(document, 'data:startpage:on-last-chance-loaded', data);
        }.bind(this);

        this._get({
            url: '/cache/StartPage/LastChance',
            dataType: 'html',
            success: onSuccess,
            cache: true
        });
    };

    this.after('initialize', function () {
        this.on(document, 'ui:startpage:on-last-chance-visible', this._lastChanceVisible);
    });
}

module.exports = defineComponent.component(LastChanceService, WithAjax);



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/data/last-chance-service.js